import { SET_HETH_LATEST_STAT } from "store/actionTypes/ethStakingActionTypes";
import { IhethInfo } from "./initalState";

export const setHethLatestStat = ({ latestHethStat, isLoading = false }: IhethInfo) => ({
  type: SET_HETH_LATEST_STAT,
  payload: { latestHethStat, isLoading },
})